import axios from 'axios';
import {
  BASE_URL,
  PAGINATION,
  USERS_URL,
  USERS__CREATE_URL,
  USERS__UPDATE_URL,
  VERIFIED_FILTER,
  SEARCH,
  STATUS_FILTER,
  GET_USER_CARD_URL,
  REMOVE_USER_CARD_URL,
  CHANGE_DEFAULT_USER_CARD_URL,
  DATE_FILTER,
  COUPON_LISTING,
  ADD_COUPON,
  DELETE_COUPON,
  UPDATE_COUPON,
  USERS_EXPORT_URL,
} from './Urls';
import {IParamsInfo} from './index.d';
export class UserApiModule {
  constructor() {}
  async getSingleUser(userId) {
    try {
      const response = await axios.get(BASE_URL + USERS_URL + '/' + userId);
      if (response.data.success) {
        return {
          status: response.status,
          success: true,
          data: response.data?.data,
          message: response.data.message,
        };
      }
      return {
        status: response.status,
        success: false,
        data: undefined,
        message: response.data.message,
      };
    } catch (error: any) {
      return {
        isNetwork: error.code === 'ERR_NETWORK',
        status: error?.response?.status,
        success: false,
        data: undefined,
        message: error.response.data.message || error.message,
      };
    }
  }

  async getUsers(paramInfo: IParamsInfo) {
    try {
      const response = await axios.get(
        BASE_URL +
          PAGINATION(USERS_URL, paramInfo.pageNo, paramInfo?.pageSize) +
          VERIFIED_FILTER(paramInfo.verifiedFilter ?? '') +
          STATUS_FILTER(paramInfo?.statusFilter) +
          SEARCH(paramInfo?.searchKeyword) +
          DATE_FILTER(paramInfo?.startDate, paramInfo?.endDate)
      );
      if (response.data.success) {
        return {
          status: response.status,
          success: true,
          data: response.data?.data,
          message: response.data.message,
        };
      }
      return {
        status: response.status,
        success: false,
        data: undefined,
        message: response.data.message,
      };
    } catch (error: any) {
      return {
        isNetwork: error.code === 'ERR_NETWORK',
        status: error?.response?.status,
        success: false,
        data: undefined,
        message: error.response.data.message || error.message,
      };
    }
  }

  async deleteUsers(userIds) {
    try {
      const response = await axios.delete(BASE_URL + USERS_URL, {headers: {}, data: userIds});
      if (response.data.success) {
        return {
          status: response.status,
          success: true,
          data: response.data?.data,
          message: response.data.message,
        };
      }
      return {
        status: response.status,
        success: false,
        data: undefined,
        message: response.data.message,
      };
    } catch (error: any) {
      return {
        isNetwork: error.code === 'ERR_NETWORK',
        status: error?.response?.status,
        success: false,
        data: undefined,
        message: error.response.data.message || error.message,
      };
    }
  }

  async getUserCard(userData) {
    try {
      const response = await axios.post(BASE_URL + GET_USER_CARD_URL, userData);
      if (response.data.success) {
        return {
          status: response.status,
          success: true,
          data: response.data?.data,
          message: response.data.message,
        };
      }
      return {
        status: response.status,
        success: false,
        data: undefined,
        message: response.data.message,
      };
    } catch (error: any) {
      return {
        isNetwork: error.code === 'ERR_NETWORK',
        status: error?.response?.status,
        success: false,
        data: undefined,
        message: error.response.data.message || error.message,
      };
    }
  }

  async removeUserCard(cardData) {
    try {
      const response = await axios.post(BASE_URL + REMOVE_USER_CARD_URL, cardData);
      if (response.data.success) {
        return {
          status: response.status,
          success: true,
          data: response.data?.data,
          message: response.data.message,
        };
      }
      return {
        status: response.status,
        success: false,
        data: undefined,
        message: response.data.message,
      };
    } catch (error: any) {
      return {
        isNetwork: error.code === 'ERR_NETWORK',
        status: error?.response?.status,
        success: false,
        data: undefined,
        message: error.response.data.message || error.message,
      };
    }
  }

  async changeDefaultUserCard(cardData) {
    try {
      const response = await axios.post(BASE_URL + CHANGE_DEFAULT_USER_CARD_URL, cardData);
      if (response.data.success) {
        return {
          status: response.status,
          success: true,
          data: response.data?.data,
          message: response.data.message,
        };
      }
      return {
        status: response.status,
        success: false,
        data: undefined,
        message: response.data.message,
      };
    } catch (error: any) {
      return {
        isNetwork: error.code === 'ERR_NETWORK',
        status: error?.response?.status,
        success: false,
        data: undefined,
        message: error.response.data.message || error.message,
      };
    }
  }

  async createUser(userData) {
    try {
      const response = await axios.post(BASE_URL + USERS__CREATE_URL, userData);

      if (response.data.success) {
        return {
          status: response.status,
          success: true,
          data: response.data.data,
          message: response.data?.data?.message,
        };
      }
      return {
        status: response.status,
        success: false,
        data: null,
        message: response.data?.data?.message,
      };
    } catch (error: any) {
      return {
        isNetwork: error.code === 'ERR_NETWORK',
        status: error?.response?.status,
        success: false,
        data: null,
        message: error.response.data.message || error.message,
      };
    }
  }

  async updateUser(userId, userData) {
    try {
      const response = await axios.put(BASE_URL + USERS__UPDATE_URL + '/' + userId, userData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.data.success) {
        return {
          status: response.status,
          success: true,
          data: null,
          message: response.data?.data?.message,
        };
      }
      return {
        status: response.status,
        success: false,
        data: null,
        message: response.data?.data?.message,
      };
    } catch (error: any) {
      return {
        isNetwork: error.code === 'ERR_NETWORK',
        status: error?.response?.status,
        success: false,
        data: null,
        message: error.response.data.message || error.message,
      };
    }
  }

  async getCouponListing(paramInfo: IParamsInfo) {
    try {
      const response = await axios.get(
        BASE_URL +
          PAGINATION(COUPON_LISTING, paramInfo.pageNo, paramInfo?.pageSize) +
          `&status=${paramInfo.statusFilter}` +
          SEARCH(paramInfo.searchKeyword) +
          DATE_FILTER(paramInfo?.startDate, paramInfo?.endDate)
      );

      if (response.data.success) {
        return {
          status: response.status,
          success: true,
          data: response?.data?.data,
          message: response.data.message,
        };
      }
      return {
        status: response.status,
        success: false,
        data: undefined,
        message: response.data.message,
      };
    } catch (error: any) {
      return {
        isNetwork: error.code === 'ERR_NETWORK',
        status: error?.response?.status,
        success: false,
        data: undefined,
        message: error.response.data.message || error.message,
      };
    }
  }
  async createCoupon(userData) {
    try {
      const response = await axios.post(BASE_URL + ADD_COUPON, userData);

      if (response.data.success) {
        return {
          status: response.status,
          success: true,
          data: response.data.data,
          message: response.data?.data?.message,
        };
      }
      return {
        status: response.status,
        success: false,
        data: null,
        message: response.data?.data?.message,
      };
    } catch (error: any) {
      return {
        isNetwork: error.code === 'ERR_NETWORK',
        status: error?.response?.status,
        success: false,
        data: null,
        message: error.response.data.message || error.message,
      };
    }
  }

  async deleteCoupon(couponIds) {
    try {
      const response = await axios.delete(BASE_URL + DELETE_COUPON, {data: couponIds});
      if (response.data.success) {
        return {
          status: response.status,
          success: true,
          data: response.data?.data,
          message: response.data.message,
        };
      }
      return {
        status: response.status,
        success: false,
        data: undefined,
        message: response.data.message,
      };
    } catch (error: any) {
      return {
        isNetwork: error.code === 'ERR_NETWORK',
        status: error?.response?.status,
        success: false,
        data: undefined,
        message: error.response.data.message || error.message,
      };
    }
  }

  async updateCoupon(Id, couponDetails) {
    try {
      const response = await axios.put(BASE_URL + UPDATE_COUPON + '/' + Id, couponDetails);
      if (response.data.success) {
        return {
          status: response.status,
          success: true,
          data: null,
          message: response.data?.data?.message,
        };
      }
      return {
        status: response.status,
        success: false,
        data: null,
        message: response.data?.data?.message,
      };
    } catch (error: any) {
      return {
        isNetwork: error.code === 'ERR_NETWORK',
        status: error?.response?.status,
        success: false,
        data: null,
        message: error.response.data.message || error.message,
      };
    }
  }


	async exportUsers(paramInfo: IParamsInfo) {
		try {
			const queryParams = new URLSearchParams();
			if (paramInfo.searchKeyword) queryParams.append('search', paramInfo.searchKeyword);
			if (paramInfo.statusFilter) queryParams.append('status', paramInfo.statusFilter);

			if (paramInfo.verifiedFilter !== undefined && paramInfo.verifiedFilter !== '') {
				queryParams.append('isVerified', paramInfo.verifiedFilter);
			}

			if (paramInfo.startDate) queryParams.append('startDate', paramInfo.startDate);
			if (paramInfo.endDate) queryParams.append('endDate', paramInfo.endDate);

			const queryString = queryParams.toString();
			const requestUrl = BASE_URL + USERS_EXPORT_URL + (queryString ? `?${queryString}` : '');

			
			const response = await axios.get(requestUrl, {
				responseType: 'arraybuffer', 
			});

			const contentType = response.headers['content-type'];

			if (response.status === 200 && contentType && contentType.includes('text/csv')) {
				const filenameFromServer = response.headers['content-disposition']
					?.split('filename=')[1]
					?.replace(/"/g, '') || `users_export_${new Date().toISOString().split('T')[0]}.csv`;

				return {
					status: response.status,
					success: true,
					data: new Blob([response.data], { type: 'text/csv' }), 
					filename: filenameFromServer,
					message: 'Users successfully exported.',
				};
			} else if (response.data) {
				
				let errorMessage = 'Export failed or unexpected response type.';
				try {
					
					const errorText = new TextDecoder('utf-8').decode(response.data as ArrayBuffer);
					const jsonData = JSON.parse(errorText);
					errorMessage = jsonData.message || 'Error during export.';
				} catch (e) {
					
					errorMessage = response.statusText || errorMessage;
				}
				return {
					status: response.status,
					success: false,
					message: errorMessage,
				};
			}
			
			return {
				status: response.status,
				success: false,
				message: response.statusText || 'Falló la exportación.',
			};

		} catch (error: any) {
			let errorMessage = 'Ocurrió un error inesperado durante la exportación.';
			let respStatus = error.response?.status;

			if (error.response && error.response.data) {
				try {
					
					const errorText = new TextDecoder('utf-8').decode(error.response.data as ArrayBuffer);
					const errorJson = JSON.parse(errorText);
					errorMessage = errorJson.message || errorMessage;
				} catch (e) {
					errorMessage = error.response?.statusText || error.message || errorMessage;
				}
			} else if (error.message) {
				errorMessage = error.message;
			}

			return {
				isNetwork: error.code === 'ERR_NETWORK',
				status: respStatus,
				success: false,
				data: undefined, 
				message: errorMessage,
			};
		}
	}

}
